import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressComponent } from './address.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NewFormatToOldService } from "./address.service";
import { TransformAddress } from "./transform-address.pipe";
import { TransformHotelName } from "./transform-hotel-name.pipe";

@NgModule({
    declarations: [
        AddressComponent,
        TransformHotelName,
        TransformAddress
    ],
    imports: [
        CommonModule,
        FontAwesomeModule
    ],
    exports: [
        AddressComponent,
        TransformHotelName,
        TransformAddress
    ],
    providers: [
        NewFormatToOldService
    ],
})
export class AddressModule {
}
